var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-appbar',{attrs:{"filterabl":""}},[_vm._v(" Transferencia Produção ")])
}
var staticRenderFns = []

export { render, staticRenderFns }